import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatIconModule, MatMenuModule, MatOptionModule, MatProgressSpinnerModule, MatSelectModule, MatSlideToggleModule, MatTooltipModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { CompanyApi } from '@api/companies.api';
import { ChartDateIntervalSelectorModule } from '@core/components/charts/chart-date-interval-selector/chart-date-interval-selector.module';
import { LineChartModule } from '@core/components/charts/line/line.module';
import { VerticalBarChartModule } from '@core/components/charts/vertical-bar/vertical-bar.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { StarsModule } from '@core/components/stars/stars.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LineMapperService } from '../../../core/components/charts/line/services/line.mapper.service';
import { ReportsModule } from '../reports.module';
import { FilterComponent } from './filter/filter.component';
import { RatingsComponent } from './ratings.component';
import { RatingsService } from './services/api/ratings-api.service';
import { RatingsMapperService } from './services/ratings.mapper.service';
import { RatingsResolverService } from './services/ratings.resolver.service';

const routes: Routes = [
  {
    path: 'relatorios/avaliacoes',
    component: RatingsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'RATINGS.TITLE' }
  }
];

@NgModule({
  declarations: [RatingsComponent, FilterComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FlexLayoutModule,
    StarsModule,
    NgxSkeletonLoaderModule,
    VerticalBarChartModule,
    FormsModule,
    LineChartModule,
    TranslateModule,
    ReportsModule,
    ChartDateIntervalSelectorModule,

    MatTooltipModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatOptionModule,
    MatSelectModule,
    MatProgressSpinnerModule,

    FcDateInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcLocationsInputModule,
    FcCompaniesInputModule,
    FcLocationGroupsInputModule
  ],
  providers: [
    LineMapperService,
    RatingsMapperService,
    RatingsResolverService,
    RatingsService,
    CompanyApi
  ],
  exports: [
    RatingsComponent
  ]
})
export class RatingsModule { }
